module.exports = __webpack_public_path__ + "media/images/icons/material/star-outline-57a3c1a265a4884b33a0c97e8100967a.svg";